const formatCnpj = cnpj => {
  if(!cnpj) return "";
  
  return cnpj
  .toUpperCase()
  .replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,"$1.$2.$3/$4-$5");
} 
  
export default formatCnpj;